import { render, staticRenderFns } from "./MenuLink.vue?vue&type=template&id=3cb820b6&scoped=true&shadow"
import script from "./MenuLink.vue?vue&type=script&lang=js&shadow"
export * from "./MenuLink.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3cb820b6",
  null
  ,true
)

export default component.exports